// Module
var code = "<massia-form form=\"true\" label=\"{{$ctrl.filter.libelle}}\"> <div ng-if=\"$ctrl.filter.values.length > 0\"> <massia-multi-select input-model=\"$ctrl.filter.values\" output-model=\"model\" item-label=\"[code] libelle\" button-label=\"[code] libelle\"></massia-multi-select> </div> </massia-form>";
// Exports
module.exports = code;